// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.brand {
  display: flex;
  padding: 15px 0;
}
.brand img {
  height: 50px;
}
.brand img, .yachtmate-header img {
  height: 50px;
}
.yachtmate-header a {
  display: flex;
}
.yachtmate-header {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px 0;
}
@media only screen and (max-width: 599px) {
  .mob-head-brand {
    display: flex !important;
    justify-content: center;
    width: 100%;
    text-align: center;
    position: absolute;
    left: 0;
    right: 0;
  }
  .mob-head-brand  a {
    display: flex;
  }
  .menu-icon {
    position: relative;
    z-index: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/HomeHeader/HomeHeader.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE;IACE,wBAAwB;IACxB,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,OAAO;IACP,QAAQ;EACV;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,UAAU;EACZ;AACF","sourcesContent":[".brand {\n  display: flex;\n  padding: 15px 0;\n}\n.brand img {\n  height: 50px;\n}\n.brand img, .yachtmate-header img {\n  height: 50px;\n}\n.yachtmate-header a {\n  display: flex;\n}\n.yachtmate-header {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 15px 0;\n}\n@media only screen and (max-width: 599px) {\n  .mob-head-brand {\n    display: flex !important;\n    justify-content: center;\n    width: 100%;\n    text-align: center;\n    position: absolute;\n    left: 0;\n    right: 0;\n  }\n  .mob-head-brand  a {\n    display: flex;\n  }\n  .menu-icon {\n    position: relative;\n    z-index: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
